<script>
import { defineComponent } from 'vue';
  const chromepluginversion = '6.10';
  const chromepluginTongbuversion = '1.0';
  const bailingVersion = '1_0_8';
  const timeRange = 63;
  const bailingInfourl = "https://ccnbqgmx3xqo.feishu.cn/wiki/RkSywSG9piNPDpkONNrcC7vYn7f?from=from_copylink";
  const dateTimeLocale = {
  "lang": {
    "locale": "zhCN",
    "placeholder": "选择日期",
    "rangePlaceholder": ["开始时间", "结束时间"],
    "today": "今天",
    "now": "Now",
    "backToToday": "回到今天",
    "ok": "确定",
    "clear": "Clear",
    "month": "Month",
    "year": "Year",
    "timeSelect": "选择时间",
    "dateSelect": "选择日期",
    "monthSelect": "选择月",
    "yearSelect": "选择年",
    "decadeSelect": "选择十年",
    "yearFormat": "YYYY",
    "dateFormat": "M/D/YYYY",
    "dayFormat": "D",
    "dateTimeFormat": "M/D/YYYY HH:mm:ss",
    "monthFormat": "MMMM",
    "monthBeforeYear": true,
    "previousMonth": "上一月 (PageUp)",
    "nextMonth": "下一月 (PageDown)",
    "previousYear": "上一年 (Control + left)",
    "nextYear": "下一年 (Control + right)",
    "previousDecade": "上一十年",
    "nextDecade": "下一十年",
    "previousCentury": "上个世纪",
    "nextCentury": "下个世纪"
  },
  "timePickerLocale": {
    "placeholder": "选择时间"
  },
  "dateFormat": "YYYY-MM-DD",
  "dateTimeFormat": "YYYY-MM-DD HH:mm:ss",
  "weekFormat": "YYYY-wo",
  "monthFormat": "YYYY-MM"
}
  

  /**
 * dataURL转Blob
 *
 * @param {*} dataurl
 * @return {*}
 */
const dataURLToBlob = (dataurl) => {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

/**
 * 复制base64
 *
 * @param {*} base64
 * @return {*}
 */
const copyBlobToClipboard = (base64) => {
  return new Promise((resolve, reject) => {
    let blob = dataURLToBlob(base64)
    navigator.clipboard
      .write([
        new window.ClipboardItem({
          [blob.type]: blob,
        }),
      ])
      .then(
        () => {
          resolve(true)
        },
        () => {
          reject(new Error('复制失败'))
        }
      )
  })
}

/**
 * 复制文本
 *
 * @param {*} text
 * @return {*}
 */
const copyTextToClipboard = (text) => {
  return new Promise((resolve, reject) => {
    navigator.clipboard.writeText(text).then(
      () => {
        resolve(true)
      },
      () => {
        reject(new Error('复制失败'))
      }
    )
  })
}

/**
 * 复制图片或文字
 *
 * @param {*} text
 * @return {*}
 */
const copyToClipboard = (opt = { type: null, value: null }) => {
  return new Promise((resolve, reject) => {
    if (opt.type === 'text') {
      copyTextToClipboard(opt.value)
        .then((res) => {
          resolve(res)
        })
        .catch(() => {
          reject(new Error('复制失败'))
        })
    } else if (opt.type === 'base64') {
      copyBlobToClipboard(opt.value)
        .then((res) => {
          resolve(res)
        })
        .catch(() => {
          reject(new Error('复制失败'))
        })
    } else {
      reject(new Error('参数错误'))
    }
  })
}

export default defineComponent({
    components:{
      chromepluginversion,
      chromepluginTongbuversion,
      dateTimeLocale,
      timeRange,
      bailingVersion,
      copyToClipboard,
      bailingInfourl
    }
  })

</script>